import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"

const PromoLanding = ({ title, items, clients, link }) => {
  const scrollToForm = () => {
    document
      .getElementById("enter")
      ?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <section className="promo-landing">
      <div className="promo-landing__inner">
        <div className="promo-landing__title">
          {title && <h2>{parse(title)}</h2>}
        </div>
        <div className="promo-landing__items">
          {items?.length > 0 &&
            items?.map((item, index) => (
              <div key={index} className="promo-landing__item">
                <div className="promo-landing__bg">
                  {item?.image && <Asset asset={item?.image} />}
                  {item?.title && <h3>{parse(item?.title)}</h3>}
                </div>
              </div>
            ))}
        </div>

        <div className="promo-landing__clients">
          <button className="btn btn--edlyn-blue" onClick={scrollToForm}>Enter Now</button>
          {clients?.length > 0 && <Asset asset={clients[0]} />}
        </div>
      </div>
    </section>
  )
}

export default PromoLanding

export const query = graphql`
  fragment PromoLandingProps on DatoCmsPromoLanding {
    ... on DatoCmsPromoLanding {
      id
      title
      items {
        image {
          ...InternalAssetProps
        }
        title
      }
      clients {
        ...InternalAssetProps
      }
      link {
        ...LinkWithTitleProps
      }
    }
  }
`
